<template>
  <div>
    <a-dropdown v-if="permission" :trigger="['click']">
      <span class="edit-priority">
        <a-tag v-if="problemUrgencys[value]" :color="problemUrgencys[value].color">{{ problemUrgencys[value].label }}</a-tag>
        <span v-else>--</span>
        <a-icon class="icon-down" type="down" />
      </span>
      <a-menu slot="overlay">
        <a-menu-item v-for="(item, key) in problemUrgencys" :key="key" @click="onChange(item.value)">
          <a-tag :color="problemUrgencys[item.value].color"> {{ problemUrgencys[item.value].label }} </a-tag>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <a-tag v-else-if="value && problemUrgencys[value]" :color="problemUrgencys[value].color"> {{ problemUrgencys[value].label }} </a-tag>
    <span v-else>--</span>
  </div>
</template>
<script>
import { problemUrgencys } from '@/utils/dictionary';
import { problemUpdateItem } from '@/api/event/problem';

export default {
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceValue: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      problemUrgencys,
      value: null
    };
  },
  computed: {
    permission() {
      return true;
    }
  },
  watch: {
    sourceValue() {
      this.value = this.sourceValue;
    }
  },
  mounted() {
    this.value = this.sourceValue;
  },
  methods: {
    onChange(value) {
      if (this.value !== value) {
        problemUpdateItem({
          id: this.sourceId,
          item: 'urgency',
          value: value
        }).then(() => {
          this.value = value;
          this.$message.success('更新成功');
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.edit-priority {
  cursor: pointer;
  display: inline-block;
  padding: 0 2px;
  line-height: 22px;
  .icon-down {
    opacity: 0;
  }
}
.edit-priority:hover {
  cursor: pointer;
  background-color: #e4e4e4;
  .icon-down {
    opacity: 1;
  }
}
/deep/.and-tag {
  margin-right: 4px;
}
</style>
